
import { h, Fragment } from 'preact'
import classnames from 'classnames'
import { useState, useRef, useEffect } from 'preact/hooks'
import { isClient } from '@util/env'
import { withHydration } from '@util/hydrate'
import { useIsIntersecting } from '@util/intersection'

import './style.less'

const ImageLoad = ({ onScroll = true, onLoaded = () => {}, ...props }) => {

	const [loaded, setLoaded] = useState(false)

	let ref = null
	let shown = false
	
	if (onScroll) {
		[ref, shown] = useIsIntersecting('0px 0px', true)
	} else {
		ref = useRef()
		shown = true
	}

	// check if already loaded
	useEffect(() => {
		if (ref.current && ref.current.complete) {
			setLoaded(true)
			onLoaded(true)
		}
	})

	const classes = classnames(
		'image-load',
		loaded && shown && isClient && 'image-load--loaded',
		// copy from component props
		props.class || props.className,
	)

	// lazy loading by default – ue 'loading="eager" as normal'
	const loading = props.loading ? props.loading : 'lazy'
	
	// delete class props, as dealt with separately
	delete props['class']
	delete props['className']

	return <img 
			ref={ref}
			loading={loading}
			onLoad={() => setLoaded(true)} 
			class={classes}
			{...props}
		/>
}

export default withHydration(ImageLoad)

